import { Component, Input, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";

@Component({
    selector: "love-it-filter-input",
    templateUrl: "./filter-input.component.html",
    styleUrls: ["./filter-input.component.scss"],
    standalone: false
})
export class FilterInputComponent implements OnInit {
  @Input() filterFormControl: FormControl;
  @Input() inputType: "text" | "number" = "text";
  @Input() placeholder: string = "Filter";

  constructor() {}

  ngOnInit(): void {}

  clearFilter() {
    this.filterFormControl.setValue(null);
  }
}
